import { render, staticRenderFns } from "./SelectCenters.vue?vue&type=template&id=a3212a16"
import script from "./SelectCenters.vue?vue&type=script&lang=js"
export * from "./SelectCenters.vue?vue&type=script&lang=js"
import style0 from "./SelectCenters.vue?vue&type=style&index=0&id=a3212a16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports